import React from 'react';
import { Box } from '@material-ui/core';
import { getCcIcon } from 'ui-elements/form-elements/FsCreditCardInput/FsCreditCardInput.utils';
import { useAppContext } from 'contexts/AppContext';
import {
  Dot,
  DotsGroup,
  LogoWrapper,
  NumberEnding,
} from './CardNumberPlaceholder.style-elements';

const CardNumberPlaceholder: React.FC = () => {
  const {
    paymentMethod: { getPaymentDetailsSnapshot },
  } = useAppContext();
  const { ccNumber, ccBrand } = getPaymentDetailsSnapshot();
  const ccIcon = getCcIcon(ccBrand?.toLowerCase(), 30);
  return (
    <Box display="flex" alignItems="center">
      <LogoWrapper>{ccIcon}</LogoWrapper>
      {[1, 2, 3].map((groupIdx) => (
        <DotsGroup key={groupIdx}>
          {[1, 2, 3, 4].map((dotIdx) => (
            <Dot key={dotIdx} />
          ))}
        </DotsGroup>
      ))}
      <NumberEnding>{ccNumber?.slice(-4)}</NumberEnding>
    </Box>
  );
};

export default CardNumberPlaceholder;
